var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2.50024,
    r: 2,
    fill: "#002438"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2.50024,
    r: 2,
    fill: "#002438",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8.50024,
    r: 2,
    fill: "#002438"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8.50024,
    r: 2,
    fill: "#002438",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 14.5002,
    r: 2,
    fill: "#002438"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 14.5002,
    r: 2,
    fill: "#002438",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDots);
export default __webpack_public_path__ + "static/media/icon-menu-dots.41e6db7841b461e5907e0212a2ee3df2.svg";
export { ForwardRef as ReactComponent };